export enum DocumentEmailsAutocompleteSourceEnum {
  NoSource = 0,
  CustomerAddress = 1,
}